import request from '@/utils/request'

//需求列表接口
export function NeedList(data) {
    return request({
      url:'/Scm.Need/index',
      method:'post',
      data:data
    })
  }

// 需求详情接口
export function NeedDetail(data) {
    return request({
      url:'/Scm.Need/detail',
      method:'post',
      data:data
    })
  }

// 变更需求列表接口
export function NeedChange(data) {
    return request({
      url:'/Scm.NeedChange/index',
      method:'post',
      data:data
    })
  }

//变更需求详情接口
export function NeedChangeDetail(data) {
    return request({
      url:'/Scm.NeedChange/detail',
      method:'post',
      data:data
    })
  }

//添加变更需求接口
export function AddNeedChange(data) {
  return request({
    url:'/Scm.NeedChange/add',
    method:'post',
    data:data
  })
}

//导入需求接口
export function importNeed(data) {
  return request({
    url: '/Scm.Need/importNeed',
    method: 'post',
    data
  })
}

//需求修改接口
export function needUpdate(data) {
  return request({
    url: '/Scm.Need/needUpdate',
    method: 'post',
    data
  })
}

//需求删除接口
export function needDel(data) {
  return request({
    url: '/Scm.Need/needDel',
    method: 'post',
    data
  })
}

//需求审核接口
export function needVerify(data) {
  return request({
    url: '/Scm.Need/needVerify',
    method: 'post',
    data
  })
}

//变更单保存
export function NeedChangeUpdate(data) {
  return request({
    url: '/Scm.NeedChange/needChangeUpdate',
    method: 'post',
    data
  })
}

//变更单审核
export function NeedChangeVerify(data) {
  return request({
    url: '/Scm.NeedChange/needChangeVerify',
    method: 'post',
    data
  })
}

//变更单取消
export function NeedChangeCancle(data) {
  return request({
    url: '/Scm.NeedChange/needChangeCancle',
    method: 'post',
    data
  })
}

//变更单关闭和反关闭
export function NeedChangeCloseChange(data) {
  return request({
    url: '/Scm.NeedChange/needChangeCloseChange',
    method: 'post',
    data
  })
}

//变更采购订单列表
export function Purchaselist(data) {
  return request({
    url: '/Scm.NeedChange/purchaselist',
    method: 'post',
    data
  })
}

//重新发起变更需求
export function NeedReAdd(data) {
  return request({
    url: '/Scm.Need/needReAdd',
    method: 'post',
    data
  })
}

//删除
export function NeedReDel(data) {
  return request({
    url: '/Scm.NeedChange/del',
    method: 'post',
    data
  })
}

//导出Excel
export function NeedExport(data) {
  return request({
    url:'/Scm.Need/needExport',
    method:'post',
    data:data,
    responseType: "blob"
  })
}

//采购历史
export function purchaseHistory(data) {
  return request({
    url: '/Crm.PurchaseOrder/purchaseHistory',
    method: 'post',
    data
  })
}

//采购历史详情
export function purchaseHistoryView(params) {
  return request({
    url: '/Crm.PurchaseOrder/purchaseHistoryView',
    method: 'get',
    params
  })
}

//导出导入错误需求接口
export function NeedErrorExport(data) {
  return request({
    url:'/Scm.Need/needErrorExport',
    method:'post',
    data:data,
    responseType: "blob"
  })
}

//采购历史导出
export function importPurchaseHistory(data) {
  return request({
    url:'/Crm.PurchaseOrder/importPurchaseHistory',
    method:'post',
    data:data,
    responseType: "blob"
  })
}

//通知
export function TipGroupPurchase(data) {
  return request({
    url: '/Scm.TipGroupPurchase/index',
    method: 'post',
    data
  })
}

//已读
export function readTip(data) {
  return request({
    url: '/Scm.TipGroupPurchase/readTip',
    method: 'post',
    data
  })
}

//采购需求变更记录导出
export function NeedChangeExport(data) {
  return request({
    url:'/Scm.NeedChange/needChangeExport',
    method:'post',
    data:data,
    responseType: "blob"
  })
}

//导出采购订单变更列表接口
export function purchaseListExport(data) {
  return request({
    url:'/Scm.NeedChange/purchaseListExport',
    method:'post',
    data:data,
    responseType: "blob"
  })
}

//客户列表接口
export function customerList(data) {
  return request({
    url: '/Scm.Need/customerList',
    method: 'post',
    data
  })
}

//定位列表
export function locationList(data) {
  return request({
    url: '/Scm.Need/locationList',
    method: 'post',
    data
  })
}

//用户列表
export function userList(data) {
  return request({
    url: '/Scm.Need/userList',
    method: 'post',
    data
  })
}

//关闭原因
export function NeedDown(data) {
  return request({
    url: '/Scm.Need/needDown',
    method: 'post',
    data
  })
}

//批量修改
export function importChangeNeed(data) {
  return request({
    url: '/Scm.Need/importChangeNeed',
    method: 'post',
    data
  })
}

/** 日催货任务列表 */
export function delayPurchaseDivision(data){
  return request({
    url:'/Scm.DelayPurchase/index',
    method: 'post',
    data: data
  })
}

/** 日催货任务列表导出 */
export function delayPurchaseExport(data){
  return request({
    url:'/Scm.DelayPurchase/export',
    method:'post',
    data: data,
    responseType: "blob"
  })
}


// WEBPACK FOOTER //
// ./src/api/procure.js